export const getGlobalMenuStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#2F2F2F',
    height: 60,
    minWidth: 'fit-content',
    paddingLeft: 0,
    paddingRight: 0,
  },
  navigationRegionContainer: {
    flexGrow: 1,
    flexShrink: 1,
  },
  item: {
    marginLeft: 0,
    marginRight: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  stretch: {
    flexShrink: 1,
    flexGrow: 1,
  },
  divider: {
    borderLeftColor: 'grey',
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    height: 40,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 10,
    width: 0,
  },
});
